import {ID, Response} from '../../../../../../_metronic/helpers'
import {FieldProps} from '../../../../../../_component/Form'

export type Application = {
  id?: ID
  job_id?: string
  full_name?: string
  email?: string
  phone?: string
  resume_url?: string
  cover_letter?: string
  answers?: any
  status?: string
  job?: any
}

export type ApplicationsQueryResponse = Response<Array<Application>>

export const fields: FieldProps[] = [
  {name: 'full_name', label: 'Full Name', required: true, table: true, sortable: true, full: false, edit: false},
  {name: 'email', label: 'Email', required: true, table: true, sortable: true, full: false, edit: false},
  {name: 'phone', label: 'Phone', required: true, table: true, sortable: false, full: false, edit: false},
  {name: 'job.title', label: 'Job Applied For', table: true, full: false, edit: false},
  {name: 'resume_url', label: 'Resume URL', type: 'link', table: false, full: true, edit: false},
  {name: 'answers', label: 'Application Answers', type: 'key-value', table: false, full: true, edit: false},
  {name: 'cover_letter', label: 'Cover Letter', type: 'textarea', table: false, full: true, edit: false},
  {
    name: 'status',
    label: 'Status',
    type: 'select',
    options: [
      {label: 'Applied', value: 'applied'},
      {label: 'Read', value: 'read'},
      {label: 'Accepted', value: 'accepted'},
      {label: 'Declined', value: 'declined'},
    ],
    table: true,
    sortable: true,
    full: false,
  },
]
